var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"bottom":"","color":"info","timeout":-1},scopedSlots:_vm._u([{key:"action",fn:function(){return [_c('v-btn',{attrs:{"text":""},on:{"click":_vm.update}},[_vm._v("OK")])]},proxy:true}]),model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',[_vm._v(_vm._s(_vm.$t('update_available')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }